<template>
  <div class="ms-4 py-1 m-2 condition-border">
    <div class="fw-bold my-1">
      {{ trans(`subscription.validation_rules.rules.specific_subscription.subscription`, { 'subscribableName' : '' }) }}
    </div>
    <select
      v-model="select"
      class="form-control form-select"
      aria-label="Default select example"
      @change="changePropertyValue(rulePropertyConstant.subscribable)"
    >
      <template v-for="(value, propertyName) in subscribables">
        <option
          :key="propertyName"
          :value="propertyName"
        >
          {{ value }}
        </option>
      </template>
    </select>
  </div>
</template>

<script>
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
import { RULE_PROPERTY } from '@/constants'
import { mapState } from 'vuex'
export default {
  name: 'RuleSpecificSubscription',
  mixins: [ruleMixin],
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
    rule: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      select: null,
      rulePropertyConstant: RULE_PROPERTY,
    }
  },
  computed: {
    ...mapState({
      subscribables (state) {
        return state.rules.subscribables
      },
    }),
  },
  mounted () {
    if (this.rule.subscribable) {
      this.select = this.rule.subscribable
    }
  },
  methods: {
    changePropertyValue (rulePropertyEnum) {
      this.rulePropertyValueChange(this.ruleReference, rulePropertyEnum, Number(this.select))
    },
  },
}
</script>

<style scoped lang='scss'>
/deep/
.form-control {
  width: auto;
}
</style>
